import React from 'react';

/** Kuroco-style 実践メモ card (改善相談). */
export default function PracticeMemoCard({ memo }) {
  if (!memo) return null;
  const headSuffix = memo.nextMonthLabel ? `（${memo.nextMonthLabel}以降に効く）` : '';
  return (
    <div className="note">
      <div className="note-head">
        {`💡 ${memo.circled} 実践メモ${headSuffix}`}
      </div>
      <div className="note-body">
        <strong>タイミング</strong>：{memo.timing}
        <br />
        <strong>対象</strong>：{memo.target}
        <br />
        <strong>一言</strong>：{memo.script}
        <br />
        <strong>忘れないコツ</strong>：{memo.tip}
      </div>
    </div>
  );
}
